import img from "../US_img/US_LEVEL.webp"; // adapte le chemin image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsLevel() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>LEVEL</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Panneaux acoustiques</h1>

          <p data-aos="fade-up">
            Panneaux acoustiques en feutre PET conçus pour le traitement
            acoustique des espaces architecturaux. Solutions durables,
            esthétiques et performantes pour murs, plafonds et mobilier.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-level.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Level panneaux acoustiques" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US LEVEL ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US LEVEL regroupe une gamme de panneaux acoustiques en feutre PET,
            composés d’au moins 50 % de bouteilles plastiques recyclées.
            Ces panneaux permettent de corriger efficacement la réverbération
            tout en apportant une solution décorative moderne.
          </p>

          <p data-aos="fade-up">
            Modulables et polyvalents, les panneaux US LEVEL peuvent être
            installés en mur, plafond, cloison ou intégrés au mobilier
            acoustique selon les besoins du projet.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="♻️"
            title="Matériau recyclé"
            text="Feutre PET composé d’au moins 50 % de plastique recyclé."
          />
          <Feature
            icon="🔇"
            title="Absorption acoustique"
            text="Réduction efficace de la réverbération et du bruit ambiant."
          />
          <Feature
            icon="📐"
            title="Différentes épaisseurs"
            text="Panneaux disponibles en 10 à 40 mm selon les besoins."
          />
          <Feature
            icon="🎨"
            title="Design et couleurs"
            text="Large choix de couleurs, formes et découpes."
          />
          <Feature
            icon="🏗️"
            title="Applications multiples"
            text="Mur, plafond, cloison ou mobilier acoustique."
          />
          <Feature
            icon="⚡"
            title="Installation simple"
            text="Pose rapide et adaptable à tous types d’espaces."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Panneaux acoustiques en feutre PET</li>
          <li>Contenu recyclé ≥ 50 %</li>
          <li>Épaisseurs disponibles : 10 à 40 mm</li>
          <li>Très bonnes performances d’absorption acoustique</li>
          <li>Installation murale, plafond ou suspendue</li>
          <li>Solution durable et écoresponsable</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Bureaux",
            "Open spaces",
            "Salles de réunion",
            "Restaurants",
            "Hôtels",
            "Espaces culturels",
            "Écoles",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Optimisez l’acoustique de vos espaces</h2>
        <p>Nos solutions US LEVEL s’adaptent à tous vos projets architecturaux.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}
